import React, { useState } from "react";
import moment from "moment";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Loader from "../../../../../../../Context/Loader/Loader";

import apiClient from "../../../../../../../Config/apiClient";
import { showSuccessToast, showErrorToast } from "../../../../../../../Context/Toaster/Toaster";
import { DATE_TIME_FORMAT } from "../../../../Utils/Constants";

const jobsPath = process.env.REACT_APP_HS_JOBS_BASE_PATH;

const JobDetailsTab = ({ jobData, refresh, onStatusChange, triggerAddModal }) => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleStatusUpdate = async () => {
    if (!selectedStatus) return;

    try {
      setIsUpdating(true);
      const response = await apiClient.put(
        `${jobsPath}/update-status`,
        { status: selectedStatus },
        { params: { id: jobData.id } }
      );

      if (response.data.status === "SUCCESS") {
        showSuccessToast("Job status updated successfully");
        if (onStatusChange) onStatusChange(selectedStatus);
        jobData.job_status = selectedStatus;
        setSelectedStatus("");
      } else {
        showErrorToast(response.data.message || "Failed to update job status");
      }
    } catch (err) {
      console.error(err);
      showErrorToast("Something went wrong while updating job status");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="vr-inner">
      <div className="vr-top">
        <div className="vrt-left">
          <h3>Job ID</h3>
          <p>{jobData.job_name}</p>
        </div>
        <div className="vrt-right">
        </div>
      </div>

      <div className="vrt-content">
        <div className="row">
          <div className="col-md-12">
            <div className="vrt-split vrt-padding">
              <h3>Description</h3>
              <p>{jobData.job_description}</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Job Type</h3>
              <p>{jobData.job_type}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Truck Type</h3>
              <p>{jobData.truck_type}</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Start Location</h3>
              <p>
                {jobData.start_location
                  ? jobData.start_location
                  : (jobData.start_location_latitude != null && jobData.start_location_longitude != null)
                    ? `(${jobData.start_location_latitude}, ${jobData.start_location_longitude})`
                    : "N/A"}
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Dump Location</h3>
              <p>
                {jobData.end_location
                  ? jobData.end_location
                  : (jobData.end_location_latitude != null && jobData.end_location_longitude != null)
                    ? `(${jobData.end_location_latitude}, ${jobData.end_location_longitude})`
                    : "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Start Time</h3>
              <p>{moment.utc(jobData.start_date_time).local().format(DATE_TIME_FORMAT)}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>End Time</h3>
              <p>{moment.utc(jobData.end_date_time).local().format(DATE_TIME_FORMAT)}</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Pay Rate (CAD)</h3>
              <p>${jobData.payment_rate}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Payment Type</h3>
              <p>{jobData.payment_type}</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Trucks Needed</h3>
              <p>{jobData.num_trucks_required}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Trucks Available</h3>
              <p>{jobData.num_trucks_applied}</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Supervisor</h3>
              <p>{jobData.supervisor ? `${jobData.supervisor.first_name} ${jobData.supervisor.last_name}` : "N/A"}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vrt-split vrt-padding">
              <h3>Job Status</h3>
              <p>{jobData.job_status}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsTab;